package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.components.OurValueItem
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/flutter/isolate")
@Composable
fun IsolatePage() {
    BlogLayout(
        PageProperties(
            "Isolate",
            "Isolates are a way to run Dart code in a separate thread, allowing developers to perform concurrent operations without blocking the main UI thread. Isolates vs. Threads. Types of isolate."
        ),
        BlogProperties("Flutter", "Isolate")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Span(Modifier.display(DisplayStyle.Contents).toAttrs()){
                SpanText(
                    text = "Concurrency allows a program to perform multiple tasks apparently at the same time. Dart achieves this using two main mechanisms: async APIs and isolates.",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                SpanText(
                    text = "Async APIs: These are functions and objects that handle non-blocking operations. This means the program can continue executing other code while waiting for an async operation to complete. Examples include Future and Stream.",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )
            }
            Ul {
                Li {
                    SpanText(
                        text = "Future represents the eventual result of an asynchronous operation. It can either be a value or an error.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Stream provides a sequence of data values delivered over time.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "The async and await keywords are used with async functions to pause execution and wait for async operations to finish.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "If your program callback is void or static, and the callback is completed insert the value this method is not static. At that isolate use. IsolateNameServer class to assign priorities to isolates and manage their lifecycle.",
                modifier = Modifier.padding(topBottom = 0.3.em)
                    .fontSize(FontSize.Medium)
            )

            SpanText(
                text = "What is a Isolates?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Isolates are a way to run Dart code in a separate thread, allowing developers to perform concurrent operations without blocking the main UI thread.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Isolates are separate instances of the Dart virtual machine (VM) that run in parallel to the main UI thread, allowing developers to execute computationally expensive or time-consuming tasks without blocking the user interface.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Each isolate has its own memory and runs concurrently, enabling true parallelism.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "They communicate with each other by sending messages. Isolates are useful for performing CPU-bound tasks in parallel on multi-core processors.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "An isolated dart execution context. Isolates are own dart instance, contains own memory allocation and event loop. All dart code runs in an isolate and code access classes and values from the same isolates.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "isolates don't share memory.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Why Are Isolates Necessary?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "The Flutter UI runs on the main thread, and any blocking task can cause jank or unresponsiveness. By offloading heavy tasks to isolates, you keep the UI smooth and responsive while the background tasks do their work independently.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Event loop & Event queue",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Event loop and event queue ensure that graphics operations and events(user type, user clicks, timer fires) are handled one at a time.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "An event loops job’s is to take an event item from event queue and handle it, repeating this steps for as long as queue isn’t empty.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Isolate communication",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Isolate don’t share state but they only communicate by messaging pattern. And this is done with Receive Port and Send Port.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Why Use Isolates in Flutter?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Flutter’s UI runs on the main isolate, also known as the UI thread.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "When you perform long-running or compute-intensive tasks on this thread, the UI can become unresponsive.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "By offloading these tasks to a different isolate, you can keep the UI smooth and responsive.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Concurrency ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Isolates provide a way to execute Dart code concurrently, allowing developers to perform multiple tasks simultaneously without interfering with the main thread.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Isolation ",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Each isolate runs in its own memory space, isolated from the main isolate (which runs the main UI thread). This isolation helps prevent potential issues such as data corruption or crashes caused by concurrent execution.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Parallelism ",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Isolates can execute code in parallel on multiple CPU cores, taking advantage of modern multi-core processors. This can lead to better performance for computationally intensive tasks.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Background Processing ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            text = "Isolates are useful for offloading tasks that might take a significant amount of time, such as network requests, file I/O, or complex computations, to run in the background without affecting the main UI thread.",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Flutter and Isolates ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Flutter itself runs on a single main isolate, where the UI is constructed and updated. However, developers can create additional isolates for specific tasks. For example, a developer might create an isolate to handle image processing or data fetching in the background.",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Safety ",
                            modifier = Modifier.padding(topBottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Due to memory isolation, isolates are inherently safer than threads. In a multi-threaded environment, developers must be diligent in managing locks and synchronization to prevent race conditions.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }
            }

            SpanText(
                text = "When to use isolates?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Image processing ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Show how isolates can be used to process images. efficiently in the background.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Heavy computations ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Demonstrate how isolates help offload CPU-intensive tasks, keeping the UI responsive.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Network requests ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Illustrate how isolates can handle network requests concurrently without blocking the main thread.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Data processing ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Discuss how isolates can be used for data analysis or transformation tasks.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }
            }

            SpanText(
                text = "Best Practices for Using Isolates",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Resource management ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Explain how to properly clean up isolates and release resources when they are no longer needed.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Error handling ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Describe techniques for handling errors and exceptions in isolates and how to propagate them to the main isolate.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Network requests ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Illustrate how isolates can handle network requests concurrently without blocking the main thread.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Span {
                        SpanText(
                            text = "Debugging ",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )

                        SpanText(
                            text = "Provide insights into debugging isolates, including tools and best practices.",
                            modifier = Modifier.padding(bottom = 0.3.em)
                                .fontSize(FontSize.Medium)
                               
                        )
                    }
                }
            }

            SpanText(
                text = "Limitations of Isolates",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Not exactly like threads (different memory spaces).",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Limited access to global variables.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Web platforms and Flutter Web don’t support isolates (use compute method).",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "No access to UI methods or rootBundle in isolates.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Limited unsolicited messages from the host platform (e.g., Firestore listeners).",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Why do we call it Isolates instead of Threads?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "The main difference is isolates do not share memory as threads do.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Why doesn’t Dart share memory between Isolates?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Most modern devices have multi-core CPUs. To take advantage of all those cores, developers sometimes use shared-memory threads running concurrently. However, shared-state concurrency is error prone and can lead to complicated code.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Instead of threads, all Dart code runs inside of isolates. Each isolate has its own memory heap, ensuring that none of the state in an isolate is accessible from any other isolate. Because there’s no shared memory, you don’t have to worry about mutexes or locks.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "A worker isolate can perform I/O (reading and writing files, for example), set timers, and more. It has its own memory and doesn’t share any state with the main isolate. The worker isolate can block without affecting other isolates.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "Isolates vs. Threads",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "Explain in detail how isolates differ from threads. Discuss the benefits of isolates, such as:",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li {
                    SpanText(
                        text = "Isolation of memory: Isolates don’t share memory by default, which reduces the risk of data corruption.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Lightweight: Isolates are more memory-efficient and lightweight compared to threads, allowing you to create many of them without excessive resource consumption.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Safe concurrency: Isolates provide a safe way to perform concurrent operations, minimizing the risk of common concurrency issues like deadlocks.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            SpanText(
                text = "2 ways to create isolate",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            SimpleGrid(
                numColumns = numColumns(
                    base = 1,
                    md = 2
                ),
                modifier = Modifier.margin(top = 0.3.em)
            ) {
                OurValueItem(
                    title = "Isolate.run",
                    description = "for executing a single computation on a separate isolate."
                )
                OurValueItem(
                    title = "Isolate.spam",
                    description = "for creating a long-lived isolate that can handle multiple messages."
                )
            }

            SpanText(
                text = "Using compute function (Easy and limited)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "The Isolate.run() method allows you to run a function within an isolate and obtain the result synchronously.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "This method is useful when you need to perform a computationally expensive task in the background and retrieve the result without blocking the main UI thread.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Flutter’s compute method, Isolate.run activates a new thread, executes the callback method, terminates the thread, and returns the result.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            KotlinCode(
                code = $$"""
                         const String filename = 'file_name.json';

                         void main() async {
                           // Read some data
                           final jsonData = await Isolate.run(() async {
                             final fileData = await File(filename).readAsString();
                             final jsonData = jsonDecode(fileData) as Map<String, dynamic>;
                             return jsonData;
                           });

                           // Use that data
                           print('Number of JSON keys: ${jsonData.length}');
                         }

                         // Produces a list of 211,640 photo objects
                         // (The JSON file is ~20MB)
                         Future<List<Photo>> getPhotos() async {
                           final String jsonString = await rootBundle.loadString('assets/photos.json');
                           final List<Photo> photos = await Isolate.run<List<Photo>>(() {
                             final List<Object?> photoData = jsonDecode(jsonString) as List<Object?>;
                             return photoData.cast<Map<String, Object?>>().map(Photo.fromJson).toList();
                           });
                           return photos;
                         }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'dart:convert';
                    import 'package:flutter/foundation.dart';

                    Future<List<User>> parseUsers(String responseBody) async {
                      return compute(_parseUsers, responseBody);
                    }
                    
                    List<User> _parseUsers(String responseBody) {
                      final parsed = jsonDecode(responseBody).cast<Map<String, dynamic>>();
                      return parsed.map<User>((json) => User.fromJson(json)).toList();
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                         int slowFib(int n) => n <= 1 ? 1 : slowFib(n - 1) + slowFib(n - 2);

                         // Compute without blocking current isolate.
                         void fib40() async {
                           var result = await Isolate.run(() => slowFib(40));
                           print('Fib(40) = $result');
                         }
                    """.trimIndent()
            )

            SpanText(
                text = "Using spawn (Advanced and flexible)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Isolate.spawn function is used to create a new isolate and run the isolateFunction in the new isolate.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "Isolate.spawn fires up a new thread, completes the callback method, returns the result, and subsequently kills the thread. The distinction lies in returning the result first, thereby reducing response time.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            KotlinCode(
                code = """
                    import 'package:flutter/foundation.dart';
                    import 'package:flutter/material.dart';

                    void main() => runApp(MyApp());
                    class MyApp extends StatelessWidget {
                      @override
                      Widget build(BuildContext context) {
                        return MaterialApp(
                          home: Scaffold(
                            body: HomePage(),
                          ),
                        );
                      }
                    }
                    class HomePage extends StatefulWidget {
                      const HomePage({Key? key}) : super(key: key);
                      @override
                      _HomePageState createState() => _HomePageState();
                    }
                    class _HomePageState extends State<HomePage> {
                      @override
                      Widget build(BuildContext context) {
                        return Center(
                          child: Column(
                            mainAxisSize: MainAxisSize.min,
                            children: <Widget>[
                              CircularProgressIndicator(),
                              ElevatedButton(
                                child: Text('start'),
                                onPressed: () async {
                                  final sum =
                                      await compute(computationallyExpensiveTask, 1000000000);
                                  print(sum);
                                },
                              )
                            ],
                          ),
                        );
                      }
                    }
                    int computationallyExpensiveTask(int value) {
                      var sum = 0;
                      for (var i = 0; i <= value; i++) {
                        sum += i;
                      }
                      print('finished');
                      return sum;
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Spam",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li {
                    SpanText(
                        text = "Spawn is more powerful and you will get more control over compute.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "You can control isolate such as pause, continue, stop the isolate.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "But you need to understand SendPort and ReceivePort to communicate between isolates.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "ReceivePort has get function name sendPort which you can send to isolate function and start listening. eg. receivePort.listen",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }

                Li {
                    SpanText(
                        text = "SendPort which will be defined in the isolate function is used to send data from the new isolate to the old isolate. eg. sendPort.send()",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                           
                    )
                }
            }

            KotlinCode(
                code = $$"""
                    import 'dart:isolate';

                    void main() async {
                        
                        final receivePort = ReceivePort();
                        
                        //Spawn an isolate
                        await Isolate.spawn(doWork, receivePort.sendPort);
                        
                        //Listen to the results from the isolate
                        receivePort.listen((data) {
                           print('Result from isolate: $data');
                           receivePort.close();
                        });
                    }

                    void doWork(SendPort sendPort)
                    {
                        int sum = 0;
                        for (int i = 0; i < 1000000000; i++) {
                            sum += i;    
                        }
                        
                        sendPort. send (sum) ;
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                       import 'dart:isolate';

                       import 'package:flutter/foundation.dart';
                       import 'package:flutter/material.dart';
                       void main() => runApp(MyApp());
                       class MyApp extends StatelessWidget {
                         @override
                         Widget build(BuildContext context) {
                           return MaterialApp(
                             home: Scaffold(
                               body: BodyWidget(),
                             ),
                           );
                         }
                       }
                       class BodyWidget extends StatelessWidget {
                         @override
                         Widget build(BuildContext context) {
                           return Center(
                             child: Column(
                               mainAxisSize: MainAxisSize.min,
                               children: <Widget>[
                                 CircularProgressIndicator(),
                                 ElevatedButton(
                                   child: Text('start'),
                                   onPressed: () async {
                                     //ReceivePort is to listen for the isolate to finish job
                                     final receivePort = ReceivePort();
                                     // here we are passing method name and sendPort instance from ReceivePort as listener
                                     await Isolate.spawn(
                                         computationallyExpensiveTask, receivePort.sendPort);
                                     //It will listen for isolate function to finish
                                     receivePort.listen((sum) {
                                       print(sum);
                                     });
                                   },
                                 )
                               ],
                             ),
                           );
                         }
                       }
                       // this function should be either top level(outside class) or static method
                       void computationallyExpensiveTask(SendPort sendPort) {
                         print('heavy work started');
                         var sum = 0;
                         for (var i = 0; i <= 1000000000; i++) {
                           sum += i;
                         }
                         print('heavy work finished');
                         //Remember there is no return, we are sending sum to listener defined defore.
                         sendPort.send(sum);
                       }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                      import 'dart:isolate';
                      import 'package:flutter/services.dart';
                      import 'package:shared_preferences/shared_preferences.dart';

                      void main() {
                        // Identify the root isolate to pass to the background isolate.
                        RootIsolateToken rootIsolateToken = RootIsolateToken.instance!;
                        Isolate.spawn(_isolateMain, rootIsolateToken);
                      }
                      Future<void> _isolateMain(RootIsolateToken rootIsolateToken) async {
                        // Register the background isolate with the root isolate.
                        BackgroundIsolateBinaryMessenger.ensureInitialized(rootIsolateToken);
                        // You can now use the shared_preferences plugin.
                        SharedPreferences sharedPreferences = await SharedPreferences.getInstance();
                        print(sharedPreferences.getBool('isDebug'));
                      }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                      import 'dart:async';
                      import 'dart:convert';
                      import 'dart:isolate';


                      void main() async {
                        final worker = Worker();
                        await worker.spawn();
                        await worker.parseJson('{"key":"value"}');
                      }


                      class Worker {

                        late SendPort _sendPort;
                        final Completer<void> _isolateReady = Completer.sync();

                        Future<void> spawn() async {
                          final receivePort = ReceivePort();
                          receivePort.listen(_handleResponsesFromIsolate);
                          await Isolate.spawn(_startRemoteIsolate, receivePort.sendPort);
                        }

                        void _handleResponsesFromIsolate(dynamic message) {
                          if (message is SendPort) {
                            _sendPort = message;
                            _isolateReady.complete();
                          } else if (message is Map<String, dynamic>) {
                            print(message);
                          }
                        }

                        static void _startRemoteIsolate(SendPort port) {
                          final receivePort = ReceivePort();
                          port.send(receivePort.sendPort);
                          receivePort.listen((dynamic message) async {
                            if (message is String) {
                              final transformed = jsonDecode(message);
                              port.send(transformed);
                            }
                          });
                        }

                        Future<void> parseJson(String message) async {
                          await _isolateReady.future;
                          _sendPort.send(message);
                        }
                      }
                    """.trimIndent()
            )
        }
    }
}

